<template>
    <div class="layout">
        <Header v-show="headerShow" />
        <div class="main">
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive" />
            </keep-alive>
            <keep-alive :include="keepAliveArray" slot="content" v-if="!$route.meta.keepAlive">
                <router-view :key="$route.fullPath"></router-view>
            </keep-alive>
        </div>
        <van-tabbar class="tabbar" :fixed="false" v-model="active" active-color="#008AFF" inactive-color="#333" placeholder @change="onChange" safe-area-inset-bottom>
            <van-tabbar-item :name="item.model" v-for="item in tabList" :key="item.name">
                <template #icon>
                    <van-icon :class-prefix="item.icon" :name="item.icon" class="myfont" />
                </template>
                {{item.name}}
            </van-tabbar-item>
        </van-tabbar>
        <div class="zhe" v-if="show">
            <div class="reward" @click="closePop">
                <span><img src="@/assets/img/close2.png" alt=""></span>
                <img src="@/assets/img/reward.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/Header";
import { mapState } from "vuex";
export default {
    data() {
        return {
            tabList:[
                // {
                //     name:'版权认证',
                //     icon: 'vant-ali-zpbqrz',
                //     model: 'apply'
                // },
                // {
                //     name:'已认证作品',
                //     icon: 'tsa-icon-wdrzzp',
                //     model: 'work'
                // },
                // {
                //     name:'作品草稿箱',
                //     icon: 'tsa-icon-wdcgx',
                //     model: 'draft'
                // },
                {
                    name:'文件/数据认证',
                    icon: 'vant-ali-sjcrz',
                    model: 'time'
                },
                {
                    name: "已认证文件",
                    icon: 'vant-ali-wenjian',
                    model: 'file'
                },
                // {
                //     name:'验证中心',
                //     icon: 'vant-ali-kexinshijianchuoyanzheng',
                //     model: 'verify'
                // },
                {
                    name:'个人中心',
                    icon: 'vant-ali-gerenzhongxin',
                    model: 'mine'
                },
            ],
            show:false
        };
    },

    components: {Header},

    computed: {
        active:{
            get(){
                return this.$route.meta.model;
            },
            set(v) {
            }
        },
        headerShow(){
            let hideHeaderPath=['/verify/Index','/mine/Account']
            //let {parentIframe} =this
            // if(parentIframe === 'ANDROID-RIGHTS' || parentIframe === 'IOS-RIGHTS' || parentIframe === 'HARMONYOSNEXT-RIGHTS'){
            //     return false
            // }
            if(hideHeaderPath.indexOf(this.$route.path) == -1){
                return true
            }else{
                return false
            }
        },
        ...mapState({
            keepAliveArray: (state) => state.app.keepAliveArray,
            parentIframe: (state) => state.app.parentIframe,
        }),
    },

    created() {
        if(this.$store.state.userInfo.userInfo.popupsStatus==1 && !this.$getlocalStorage('popups')){
            this.show=true;
        }
        let {parentIframe} =this
        if(parentIframe === 'ANDROID-RIGHTS' || parentIframe === 'IOS-RIGHTS' || parentIframe === 'HARMONYOSNEXT-RIGHTS'){
            this.tabList.pop();
        }
        
    },

    mounted() {},

    methods: {
        closePop(){
            this.show=false;
            this.$setlocalStorage('popups',true)
        },
        onChange(name){
            switch (name) {
                case 'time':
                    this.$router.push({name:'ApplyTime'})
                    break;
                case 'file':
                    this.$router.push({name:'ProtectFile'})
                    break;
                // case 'verify':
                //     //window.open(process.env.VUE_APP_VERIFY)
                //     this.$router.push({name:'Verify'})
                //     break;
                // case 'copyright':
                //     this.$router.push({name:'CopyrightIndex'})
                //     break;
                // case 'apply':
                //     this.$router.push({name:'CopyrightIndex'})
                //     break;
                // case 'work':
                //     this.$router.push({name:'CertifiedWork'})
                //     break;
                // case 'draft':
                //     this.$router.push({name:'MyDraft'})
                //     break;
                case 'mine':
                    this.$router.push({name:'MyInfo'})
                    break;
            }
        }
    },
};
</script>
<style lang="less" scoped>
.myfont{
    font-size:24px;
}
.layout{
    height: 100%;
    width: 100%;
    position: absolute;
    display: flex;
    flex-direction: column;
    .main{
        display: flex;
        flex: 1;
        overflow-y: hidden;
        z-index: 1000;
    }
}
.tabbar {
    z-index: 0;
}
.zhe{
    display: flex;
    position: fixed;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .3);
    justify-content: center;
    align-items: center;
    .reward{
        cursor: pointer;
        position: relative;
        height: 273px;
        span{
            position: absolute;
            top:0;
            right: 10px;
            img{
                width: 25px;
                height: 25px;
            }
        }
    }
}
</style>
